import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import store from "../../../store";
module.exports = {
    ...twLocale,
    netError: "網絡連接錯誤，請稍後重試",
    cancel:"取消",
    confirm:"確認",
    delete:"刪除",
    save:"保存",
    rename:"重命名",
    userSpace: "個人空間",
    entSpace: "企業空間",
    allUser: "所有用戶",
    frozen: "已凍結",
    upload: "上傳",
    import: "導入",
    tips: "提示",
    success: "成功",
    prompt: "提示",
    return: "返回",
    edit:"編輯",
    close: "關閉",
    noSearch: "搜索無結果",
    loadmore: "加載更多",
    retry: "重試",
    allDelete: "全部刪除",
    nextStep:"下一步",
    nodata:'沒有相關的查詢結果',
    back: "上一步",
    gotIt:"知道了",
    edas: {
        loginIcon: '登入圖標',
        filterCondition: "設置過濾條件",
        enterFilter: '設置過濾條件後，會將Base DN下的節點按照設定的過濾條件進行過濾，目前支持LDAP filter語法格式，如cn=D_group1',
        title: '企業賬戶認證服務配置',
        subHeader: '您可以將開放平臺與企業域對接，快速導入及同步企業已有用戶和組織架構。',
        importServerConfig: '組織導入服務配置',
        sync: '組織導入服務配置',
        authServerConfig: '登錄認證服務配置',
        auth: '登錄認證服務配置',
        agentName: '代理名稱',
        serviceName: '服務名稱',
        serial: '序列號',
        ctime: '創建時間',
        status: '狀態',
        authentication: '企業認定',
        operation: '操作',
        addAgentServer: '添加服務代理',
        cancel: '取消',
        confirm: '確定',
        next: '下一步',
        last: '上一步',
        serviceList: '服務清單',
        all: 'Select all',
        addServerConfig: '添加服務配置',
        editServerConfig: '编辑服务配置',
        autoSyncTime: '自動同步時間',
        lastSyncTime: '上次同步時間',
        newAgentSrver: '新建代理服務',
        unbound: '解除綁定',
        delete: '刪除',
        unbind: '未綁定',
        normal: '正常',
        disconnect: '斷開',
        unboundTips: '解除綁定後，該代理服務不可用，是否繼續解除？',
        confirmUnbound: '繼續解除',
        deleteTips: '刪除後，該服務將解綁並清除相關參數，是否繼續？',
        tips: '提示',
        serviceType: '服務類型',
        ad: 'AD',
        corpWX: '企業微信',
        dingding: '釘釘',
        none: '無',
        submit: '提交',
        connectConfig: '連接配置',
        serviceAddress: '服務器地址',
        serviceManageAccount: '服務器管理賬號',
        password: '密碼',
        baseDN: 'Base DN',
        port: '端口',
        appId: 'appId',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        fieldMapping: '字段映射',
        userID: '用戶標識字段',
        userNameField: '用戶名稱字段',
        emailField: '用戶郵箱字段',
        mobileField: '用戶手機字段',
        login: '用戶登錄字段',
        teamID: '團隊標識字段',
        teamName: '團隊名稱字段',
        allowMailImportToBeEmpty: '郵件導入允許為空',
        mailImportToolTip: '如果去掉勾選，及不允許為空，則郵箱為空的用戶不導入',
        customField: '自定義字段',
        lenovoboxField: '網盤字段',
        importField: '導入字段',
        addField: '添加字段',
        syncConfig: '同步配置',
        defaultImportMode: '默認導入方式',
        allImport: '全部導入',
        allNoImport: '全部不導入',
        syncTime: '同步執行時間',
        accordingDay: '按天',
        accordingHour: '按時',
        hour: '時',
        min: '分',
        hours: '時',
        mins: '分',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        adfsCertificate: 'adfs证书 (jks格式)',
        certificatePassword: '證書密碼',
        adfsAddress: 'ADFS地址',
        everyday: '每天',
        every: '每',
        syncOperation: '立即同步',
        log: '日誌',
        more: '更多',
        setServiceConfig: '設置服務配置',
        setFiltrationConditions: '設置過濾條件',
        deleteSuccess: '刪除成功',
        back: '返回',
        syncCompleteTime: '同步完成時間',
        syncSuccess: '同步成功',
        syncFail: '同步失敗',
        unSync: '未同步',
        unSyncToolTip: '通過黑名單過濾未同步的數據',
        detail: '詳情',
        export: '導出',
        syncDetail: '同步詳情',
        object: '對象',
        action: '動作',
        detailSyncTime: '同步時間',
        allSyncResult: '全部同步結果',
        failReasons: '失敗原因',
        success: '成功',
        fail: '失敗',
        user: '用戶',
        team: '團隊',
        created: '創建',
        update: '更新',
        frozen: '凍結',
        unfrozen: '解凍',
        filter: '已過濾',
        unSyncUser: '未同步用戶',
        unSyncTeam: '未同步團隊',
        unSyncOrganization:'未同步組織',
        netError: "網絡連接錯誤，請稍候重試",
        importServiceConfigCuccess: '添加導入服務配置成功！',
        filterInquiry: '是否立即去設置導入過濾條件？',
        noSettings: '暫不設置',
        goSettings: '前往設置',
        setFilter: '設置過濾條件',
        addFilter: '添加條件',
        addFilterCondition: '添加過濾條件',
        modifyFilterCondition: '修改過濾條件',
        batchImport: '批量導入',
        userEmail: '用戶郵箱',
        userPhone: '用戶手機',
        userName: '用戶名稱',
        teamUser: '團隊名稱',
        filteringContent: '過濾內容',
        allConditionalType: '全部條件類型',
        allFilterMode: '全部過濾方式',
        import: '導入',
        noImport: '不導入',
        modify: '修改',
        conditionalType: '條件類型',
        filterMode: '過濾方式',
        importModeDesc: '導入方式可在服務配置中修改',
        addedNumber: '已添加',
        addedText: '個條件',
        first: '第一步',
        downloadTemp: '下載模板',
        downloadTempDesc: 'xls或xlsx文件',
        second: '第二步',
        editedUpload: '編輯內容後，上傳',
        upload: '上傳',
        edit: '編輯',
        uploadCertificate: '上傳證書',
        deleteItem: '刪除選中項',
        selectedText: '確定選中刪除的',
        importLogTitle: '導入服務配置列表',
        mostNumber: '最多10條字段',
        enterLenovoboxField: '請輸入網盤字段',
        enterImportField: '請輸入導入字段',
        hasAddAgentServer: '代理服務已添加',
        agentRelease: '代理綁定已解除',
        noServiceConfig: '未添加服務配置',
        noAgentService: '未添加代理服務',
        syncConfigDesc: '提交後，可添加過濾條件篩選部分用戶',
        noDetailResulr: '沒有相應的搜索結果',
        filterTitleTip: '默認導入全部數據，可設置全部不導入，通過添加條件來導入部分數據',
        importAcount: '總計導入',
        condition: '個條件',
        copy: '複製',
        copySuccess: '複製成功',
        copyFail: '複製失敗',
        serviceNamePlaceholder: '請輸入服務配置名稱，最多50個字符',
        serviceAddressPlaceholder: '例如：120.22.100.11',
        manageAccountPlaceholder: '請輸入將要連接的服務器管理員賬號',
        enterPasswordPlaceholder: '請輸入密碼',
        enterSearchValue: '請輸入搜索內容',
        selectFilterType: '請選擇過濾條件類型',
        enterEmail: '請輸入用戶郵箱',
        enterUserPhone: '請輸入用戶手機',
        enterUserName: '請輸入用戶名稱',
        enterTeamName: '請輸入團隊名稱',
        noSearchResult: '請換個關鍵詞再試試',
        loadMore: '加載更多',
        beyondLimit: '超出10000條上限',
        configSuccess: '配置成功',
        deleteConfirm: '確認刪除？',
        item: '个',
        items: '項',
        noFilterSearchResult: '無相應的搜索結果，請換個關鍵詞再試試',
        character: '請輸入服務配置名稱，最多50個字符',
        noErrorSpecialCharacters: '不允許輸入以下特殊字符"\\/:*?"<>|"',
        isSyncing: '執行同步中',
        jksFile: 'jks格式',
        uploadJksFile: '請上傳jks格式文件',
        inputCertificatePassword: '請輸入證書密碼',
        address: '請輸入地址',
        modifySuuccess: '修改成功',
        agentPlaceholder: '請輸入代理服務名稱，最多50個字符',
        inputTeamOrUser: '輸入用戶名/團隊搜索',
        addFilterSuccess: '添加過濾條件成功',
        modifyFilterSuccess: '修改過濾條件成功',
        errorEmail: '郵箱格式不正確',
        errorMobile: '手機格式不正確',
        agentId: 'agentId',
        bindingServerConfig: '第三方綁定服務配置',
        matchingRule: '匹配規則',
        mobile: '手機號',
        email: '郵箱',
        syncResult: '同步結果',
        newBinding: '新綁定',
        failBinding: '綁定失敗',
        account: '賬號',
        bindingLogTitle: '綁定配置的日誌列表',
        inputAccount: '請輸入賬號',
        weaver:'泛微',
	    weaverOA:'泛微OA',
        customize: '自定義',
	    URL:'URL',
        urlTip:'請輸入帶http://或https://的URL',
        departmentID: '部門標識字段',
        departmentName: '部門名稱字段',
        parentDepartment:'父部門',
        agentTips:'當前服務類型無需選擇代理名稱',
        syncMode: '同步方式',
        syncOrganization: '同步到組織',
        syncTeam: '同步到團隊',
        syncUserOnly: '僅同步用戶',
        syncOrganizationToolTip: '將對接系統的組織和人員同步到網盤組織中',
        syncTeamToolTip: '將對接系統的人員同步到組織下，將對接系統的組織結構同步到團隊中',
        syncTeamToolTipNotEnterPrise: '將對接系統的組織結構同步到團隊中',
        syncUserOnlyToolTip: '僅將對接系統的人員同步到組織根節點下，不同步組織',
        syncUserOnlyToolTipNotEnterPrise: '僅將對接系統的人員同步到團隊根節點下，不同步組織',
        remarks: '備註',
        move: '移動',
        organization:'組織',
        mostCustomNumber: '最多{0}條字段',
        createAgentFirst: '請先配置代理服務',
        hasNoAgentNow: '暫無代理服務',
        notNeedAgent: '當前服務類型無需選擇代理名稱',
        connectFieldName: '連接配置項名稱',
        connectFieldContent: '連接配置項內容',
        enterConnectFieldName: '請輸入連接配置項名稱',
        enterConnectFieldContent: '請輸入連接配置項內容',
        signCongit: "掃碼登入服務配寘",
        SSO: "單點登錄（SSO）服務配寘",
        sso: "單點登錄（SSO）服務配寘",
        searchSuccess: '査詢成功',
        allSuccess:'Success',
        startSuccess:'Success',
        closeSuccess:'Success',
        uploadSuccess:'Success',
        scanName: '登錄名',
        boxUrl: '網盤訪問地址',
        copyUrl: '複製地址',
        identification: '匹配標識',
        appKeySecret: 'appKeySecret',
        ssoWarning: '由於您使用了代理服務，系統無法獲取到代理伺服器地址，囙此請您在使用網盤訪問地址時，需手動將代理服務的IP或地址填寫在xxx位置，例如：https://lenovows.com/user/manage',
        agentWarning: '代理服務最多添加1個配寘',
        importWarning: '組織導入服務最多添加1個配寘',
        authWarning: '登入認證服務最多添加1個配寘',
        schema: 'schema',
        userStatus: '使用者狀態',
        probation:'試用',
        formal:'正式',
        temporary:'臨時',
        probationExtension:'試用延期',
        dismissal:'解聘',
        resignation:'離職',
        retirement:'退休',
        invalid:'無效，只同步正式用戶',
        importSealTeam:'導入封存團隊',
        yes:'是',
        no:'否',
        relationship: '關係',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'應用憑證',
        applicationVoucherTitle:'配寘連接釘釘的應用憑證，用於獲取釘釘用戶的基礎資訊',
        scanLogin:'掃碼登入',
        qrcode:'掃碼登入',
        scanLoginTitle:'配寘釘釘掃碼登入應用授權資訊，以實現釘釘掃碼登入網盤',
        mobileAuthorizedLogin:'移動端授權登入',
        mobileAuthorizedLoginTitle:'配寘釘釘“移動應用接入-分享”授權資訊，以實現移動端可以通過釘釘授權登入',
        kingdee: '金蝶雲',
        createSuperiorTeam: '自動創建上級團隊',
        createSuperiorOrg: '自動創建上級組織',
        autCreateSuperiorTeam: '添加的過濾條件同步到團隊時自動創建上級團隊',
        autCreateSuperiorOrg: '添加的過濾條件同步到組織時自動創建上級組織',
        ...store.getters['tw']
    },
    app: {
        'thirdApp': '協力廠商應用',
        'appManager': '應用管理',
        'createApp': '創建應用',
        'editApp': '修改應用',
        'appName': '應用名稱',
        'appDesc': '應用描述',
        'appIcon': '應用圖標',
        'ipManage': 'IP管理',
        'addIp': '添加IP訪問',
        'appNameTip': '請輸入應用名稱，不超過50個字元',
        'addIpDesc': '填寫訪問此應用的IP，多個IP請以“，”隔開，支持填寫IP段，IP起始地址與終止地址使用“-”隔開',
        'rateLimit': '介面頻率限制',
        'setRateLimit': '設定介面頻率',
        'rateLimitDesc': '為防止應用程序頻繁調用而引發服務器負載异常，默認情况下，每個服務端介面調用都有頻率限制，當超過此限制時，調用對應介面時會返回對應錯誤碼。',
        'rateLimitNumber': '需要提示上限數位',
        'rateLimitUnit': '次/分鐘',
        'appVoucher': '應用憑證',
        'baseInfo': '基礎資訊',
        'appAvatar': '應用圖標',
        'editInfo': '編輯資訊',
        'backUp': '返回應用管理',
        'deleteApp': '删除應用',
        'voucher': '憑證與基礎資訊',
        'authManage': '許可權管理',
        'createSuccess': '創建成功',
        'createError': '創建失敗',
        'modifySuccess': '修改成功',
        'modifyError': '修改失敗',
        'delSuccess': '删除成功',
        'delError': '删除失敗',
        'modifyAuthSuccess': '批量設定成功',
        'modifyAuthError': '批量設定失敗',
        'deleteConfirm2': '删除確認',
        'appNumLimit': '應用數量達到上限，無法繼續創建',
        'ipFormatError': 'IP範圍格式錯誤',
        'deleteConfirmTitle': '您確定要删除該應用嗎？',
        'deleteDesc': '請檢查應用資訊，删除後不可恢復，憑證將失效',
        'imgFormatLimit': '僅支持上傳JPG/PNG格式',
        'imgBulkLimit': '圖片必須小於120KB',
        'imgSizeLimit': '圖片必須為240*240px以上',
        'imgTip': '請上傳JPG/PNG格式、240*240px以上、1:1、120kb以內的無圓角圖標',
        'appNameRequired': '應用名稱不能為空',
        'appNameIsExit': '應用名稱已被佔用',
        'ipRequired': '請添加訪問IP'
    },
};



// WEBPACK FOOTER //
// ./static/js/language/tw.js